import React, {Component, Fragment} from 'react';
import {
  Card,
  CardBody,
  Row,
  Col,
  Form,
  CardTitle,
} from 'reactstrap';
import {Field, Form as FinalForm} from 'react-final-form';
import {withTranslation} from 'react-i18next';
import TextField from '../../../../components/TextField';
import {Colxx, Separator} from '../../../../components/common/CustomBootstrap';
import {NotificationManager} from '../../../../components/common/react-notifications';
import {formats, modules} from '../../../../constants/editorConfig';
import {emailFormat, required} from '../../../../helpers/Validators';
import LoaderButton from '../../../../components/LoaderButton';
import Breadcrumb from '../../../../containers/navs/Breadcrumb';
import FieldError from '../../../../components/FieldError';
import CreatableSelect from 'react-select/creatable';
import ReactQuill, {Quill} from 'react-quill';
import {find, forEach, indexOf} from 'lodash';
import {store} from '../../../../AppRenderer';
import Api from '../../../../services/Api';
import Select from 'react-select';
import {map} from 'lodash';

let AlignStyle = Quill.import('attributors/style/align');
let BackgroundStyle = Quill.import('attributors/style/background');
let ColorStyle = Quill.import('attributors/style/color');
let DirectionStyle = Quill.import('attributors/style/direction');
let FontStyle = Quill.import('attributors/style/font');
let SizeStyle = Quill.import('attributors/style/size');

Quill.register(AlignStyle, true);
Quill.register(BackgroundStyle, true);
Quill.register(ColorStyle, true);
Quill.register(DirectionStyle, true);
Quill.register(FontStyle, true);
Quill.register(SizeStyle, true);

const components = {
  DropdownIndicator: null,
};

const createOption = label => ({
  label,
  value: label,
});

class Create extends Component {
  constructor(props) {
    super(props);
    this.state = {
      destInputValue: '',
    };
    const {groupMessageSettings} = store.getState().app;
    // this.options = map(groupMessageSettings['EMAIL'].destinationCategories, ({type, localeName}) => ({
    //   label: localeName,
    //   value: type,
    // }));
    this.options = [];
  }

  handleInputChange = destInputValue => {
    this.setState({ destInputValue });
  };

  handleKeyDown = (event, input) => {
    const { destInputValue } = this.state;
    if (!destInputValue) return;
    switch (event.key) {
      case 'Enter':
      case 'Tab':
        this.setState({
          destInputValue: '',
        });
        input.onChange([...input.value, createOption(destInputValue)]);
        event.preventDefault();
    }
  };

  sendEmail = async values => {
    const {t} = this.props;
    const {subject, message, destinations, destinationCategories} = values;
    const categories = destinationCategories.map(obj => obj.value);
    try {
      await Api.invoke('POST', '/admin-ui/group-message', {
        type: 'EMAIL',
        subject,
        message,
        destinationCategories: categories,
        ...(indexOf(categories, 'SELECTED_USERS') >= 0 ?
            {destinations: destinations.map(obj => obj.value)} : null
        ),
      });
      NotificationManager.success(t('Group email sent successfully'), t('Message'));
    } catch (e) {
      if (e.fieldError) {
        return e.fieldError;
      }
      throw e;
    }
  };

  CategoriesSelectAdapter = ({input, ...rest}) => (
    <Select
      {...input}
      {...rest}
      isMulti
      placeholder={this.props.t('Select')}
    />
  );

  DestinationsSelectAdapter = ({input, ...rest}) => (
    <CreatableSelect
      {...input}
      {...rest}
      isClearable
      isMulti
      menuIsOpen={false}
      components={components}
      inputValue={this.state.destInputValue}
      onInputChange={this.handleInputChange}
      onChange={value => {input.onChange(value);}}
      onKeyDown={e => {this.handleKeyDown(e, input);}}
      placeholder={this.props.t('Type destination mobile number and press enter...')}
    />
  );

  validate = values => {
    const error = {};
    const {destinations, destinationCategories} = values;
    if (!!find(destinationCategories, ['value', 'SELECTED_USERS']) && destinations) {
      if (destinations.length) {
        forEach(destinations, obj => {
          const err = emailFormat(obj.value);
          if (err) {
            error.destinations = err;
            return false;
          }
        });
      } else {
        error.destinations = this.props.t('Required');
      }
    }
    return error;
  };

  render() {
    const {t, match} = this.props;
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb match={match}/>
            <Separator className="mb-5"/>
          </Colxx>
        </Row>
        <Row>
          <Colxx xxs="12" className="mb-4">
            <Card className="h-100">
              <CardBody>
                <CardTitle className="text-large text-primary">
                  {t('Send Group Email')}
                </CardTitle>
                <FinalForm
                  onSubmit={this.sendEmail}
                  validate={this.validate}
                  render={({values, handleSubmit, submitting, pristine, hasValidationErrors}) => {
                    const {destinationCategories} = values;
                    return (
                      <Form>
                        <Row>
                          <Col className='col-lg-6 col-md-12'>
                           <span>
                             {t('Send to')}
                             <span className="required">*</span>
                           </span>
                            <Field
                              name="destinationCategories"
                              component={this.CategoriesSelectAdapter}
                              options={this.options}
                              closeMenuOnSelect={false}
                              validate={required}
                            />
                            <FieldError name='permissions' />
                          </Col>
                        </Row>
                        {!!destinationCategories && !!find(destinationCategories, ['value', 'SELECTED_USERS']) &&
                          <Row className='mt-2'>
                            <Col className='col-lg-6 col-md-12'>
                                <span>
                                  {t('Destination Emails')}
                                  <span className="required">*</span>
                                </span>
                              <Field
                                name="destinations"
                                component={this.DestinationsSelectAdapter}
                              />
                              <FieldError name='destinations' />
                            </Col>
                          </Row>
                        }
                        <Row className='mt-2'>
                          <Col>
                            <TextField
                              item={{
                                required: true,
                                name: 'subject',
                                i18n: t('Subject'),
                                type: 'text',
                              }}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <span>
                             {t('Message')}
                              <span className="required">*</span>
                            </span>
                            <Field name='message' validate={required}>
                              {({input}) => (
                                <ReactQuill
                                  {...input}
                                  theme='snow'
                                  modules={modules}
                                  formats={formats}
                                />
                              )}
                            </Field>
                            <FieldError name='message' />
                          </Col>
                        </Row>
                        <LoaderButton
                          loading={submitting}
                          onClick={handleSubmit}
                          disabled={pristine || hasValidationErrors || submitting}
                          className="mt-4 text-center"
                          style={{minWidth: '100px'}}>
                          {t('Submit')}
                        </LoaderButton>
                      </Form>
                    );
                  }}
                />
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      </Fragment>
    );
  }
}

export default withTranslation()(Create);
